/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
*/

// IP-NOTICE: PROTECTED
import { Component, ContentChild, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FilterFieldsBaseComponent } from 'app/shared/components/list-filter/filter-fields-base.component';
import { Filter } from 'app/shared/models/filter.model';
import { Subject } from 'rxjs';

@Component({
	selector: 'list-filter',
	templateUrl: './list-filter.component.html',
	standalone: false,
})
export class ListFilterComponent implements OnInit {
	@Input() showButtons = true;
	@Input() showFilters = true;
	@Input() title = '';
	@ContentChild(FilterFieldsBaseComponent, { static: true }) filterFields: FilterFieldsBaseComponent;
	@Output() filterChanged = new EventEmitter<Array<Filter>>();
	@Output() showFiltersChanged = new EventEmitter<boolean>();

	private ngUnsubscribe: Subject<boolean> = new Subject();

	constructor() {}

	get hasTitle(): boolean {
		return typeof this.title === 'string' && this.title.trim().length > 0;
	}

	ngOnInit() {
		this.filterFields.filterChanged.subscribe((params) => {
			this.applyFilter(true);
		});
	}

	ngAfterViewInit() {}

	ngOnDestroy() {
		this.ngUnsubscribe.next(true);
		this.ngUnsubscribe.complete();
	}

	toggleDisplay() {
		this.showFilters = !this.showFilters;
		this.showFiltersChanged.emit(this.showFilters);
	}

	applyFilter(filterOnInitOrReset = false) {
		// filter should only be allpied if the filter has values, is loaded for the first time in the onInit, or if the filter is reset
		// the filter button is disabled if !hasFilters(), this check is to prevent filtering on the enter key
		var hasFilters = this.hasFilters();
		if (hasFilters || filterOnInitOrReset) {
			const filters = this.filterFields.getFilters();
			this.filterChanged.emit(filters);
			this.filterFields.markPristine();
		}
	}

	resetFilter() {
		this.filterFields.resetToDefault();
		this.applyFilter(true);
	}

	hasFilters() {
		if (this.filterFields === null || this.filterFields === undefined) {
			return false;
		}
		return this.filterFields.hasFilters();
	}
}
